import { render, staticRenderFns } from "./audio-icon.vue?vue&type=template&id=4847f9c4&scoped=true"
var script = {}
import style0 from "./audio-icon.vue?vue&type=style&index=0&id=4847f9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4847f9c4",
  null
  
)

export default component.exports